import { c as _c } from "react/compiler-runtime";
import { ArrowRight, Ruler } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/app-ui/EmptyState';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/use-translation';

/**
 * What an Analyze figure says before the first reading: that it fills in as
 * the keys are measured, and where they are.
 */
export const MeasureFirst = () => {
  const $ = _c(14);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Ruler />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("No measurement yet");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("Enter the weights of your keys in Measure: the figure fills in as you go.");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("Start measuring");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowRight />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <Button asChild={true} className="min-h-[46px]"><Link to="/measure">{t3}{t4}</Link></Button>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t5) {
    t6 = <EmptyState icon={t0} title={t1} text={t2} actions={t5} />;
    $[10] = t1;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};